import { render } from "./about.vue?vue&type=template&id=7289c4c1&scoped=true&ts=true"
import script from "./about.vue?vue&type=script&lang=ts"
export * from "./about.vue?vue&type=script&lang=ts"

import "./about.vue?vue&type=style&index=0&id=7289c4c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7289c4c1"]])

export default __exports__